module.exports = __webpack_public_path__ + "img/result-restore-btn.dd9f06c5.png";